import React, { Children, cloneElement, isValidElement } from 'react'

async function writeText(text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
    return
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

/**
 * Drop-in for `react-copy-to-clipboard`.
 * Clones the single child and copies `text` on click.
 */
export function CopyToClipboard({ text, onCopy, children  }) {
  const child = Children.only(children)

  const handleClick = async (event) => {
    if (isValidElement(child) && typeof child.props.onClick === 'function') {
      child.props.onClick(event)
    }
    if (event?.defaultPrevented) return

    const value = text == null ? '' : String(text)
    try {
      await writeText(value)
      onCopy?.(value, true)
    } catch {
      onCopy?.(value, false)
    }
  }

  if (!isValidElement(child)) return null
  return cloneElement(child, { onClick: handleClick  })
}

export default CopyToClipboard
